import { render, staticRenderFns } from "./ModelTable.vue?vue&type=template&id=6780622c&scoped=true"
import script from "./ModelTable.vue?vue&type=script&lang=js"
export * from "./ModelTable.vue?vue&type=script&lang=js"
import style0 from "./ModelTable.vue?vue&type=style&index=0&id=6780622c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780622c",
  null
  
)

export default component.exports